import React, { useState } from "react";
import "./Bonus_Details.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Filter_Drop from "../Common/Common_Component/Filter_Drop/Filter_Drop";
import { Tabs, Tab } from "react-bootstrap";
import BonusDetails_card from "./BonusDetails_card/BonusDetails_card";
import No_data from "../Common/No_data/No_data";

function Bonus_Details() {
  const [key, setKey] = useState("received");

  return (
    <>
      <section className="Bonus_Details">
        <Common_white_header headingText={"Bonus Details"} />
        <div className="container">

            {/* filters and list */}
          <Filter_Drop />
          {/* tabs for status */}
          <Tabs
            activeKey={key}
            onSelect={(k) => setKey(k)}
            className="mb-3 bonus-tabs"
          >
            <Tab eventKey="tobe" title="To be collected" />
            <Tab eventKey="received" title="Received" />
            <Tab eventKey="expired" title="Expired" />
          </Tabs>

          

          <BonusDetails_card status={key} />

          
        </div>
      </section>
    </>
  );
}

export default Bonus_Details;
